import React, {Component} from 'react'

class Timeline extends Component {
    render() {
        return (
            <div className="timeline">
                <div className="timeline-date">
                    <h6 className="font-family-tertiary font-small font-weight-normal uppercase">
                        {this.props.from} - {this.props.to}</h6>
                </div>
                <div className="timeline-content">
                    <h6 className="font-weight-normal">{this.props.title}</h6>
                    <p>{this.props.description}</p>
                </div>
            </div>
        )
    }
}

export default Timeline